<template>
	<div style="width: 100%;background-color: #fff;">
		<div class="smallHeaderBox">
			<div style="width: 1200px;margin: 0 auto;overflow: hidden;">
				<div class="smallHeader">
					欢迎您来到科技成果转化公共服务平台！
				</div>
				<div class="backhome" v-if="user.phoneNumber">

					<a-dropdown>
						<template #overlay>
							<a-menu>
								<a-menu-item key="3">
									<a @click="onLogout">
										<PoweroffOutlined /> 退出登录
									</a>
								</a-menu-item>
							</a-menu>
						</template>
						<a class="ant-dropdown-link" style="margin-left:20px;position:relative;padding:0 10px 0 10px"
							@click="islogin">
							<img style="position:absolute; left:-5px; top:0px" src="@/assets/img/login.png" alt=""> {{
								user.phoneNumber }}
						</a>
					</a-dropdown>

				</div>
				<div class="backhome" v-else>
					<img src="@/assets/img/login.png" />
					<span @click="goMore('/login', 'user')" style="margin-left: 10px;">登录</span>
					<a-divider class="lineBox" type="vertical" />
					<span class="resigierBox" @click="this.$router.push('/register')">注册</span>
					<a-divider class="lineBox" type="vertical" />
				</div>
				<div class="backhome" style="margin-right:20px">
					<a-dropdown>
						<template #overlay>
							<a-menu>
								<a-menu-item @click="goMoreNotice('/Innovation/index', { type: '首页' })" key="2">
									创新创业
								</a-menu-item>
								<a-menu-item @click="goMoreNotice('/finance/index', { type: '首页' })" key="3">
									科技金融
								</a-menu-item>
								<a-menu-item @click="goMoreNotice('/knowledge/index', { type: '首页' })" key="4">
									知识产权
								</a-menu-item>
								<a-menu-item @click="goHttp('https://www.yqgxqsc.com/talent/#/home')" key="5">
									科技人才
								</a-menu-item>
								<a-menu-item @click="goMoreNotice('/achievements/index', { type: '首页' })" key="6">
									成果转化
								</a-menu-item>
							</a-menu>
						</template>
						<a class="ant-dropdown-link" @click="goMore('/')">
							<!-- <HomeOutlined />  -->
							首页
							<DownOutlined />
						</a>
					</a-dropdown>
				</div>
			</div>
		</div>
		<div class="headerBox">
			<div class="hearderContentBox">
				<div class="titleBox">
					<div class="logoBox">
						<img :src="getImg(all_logo)" alt="">
					</div>
					<span style="margin-left: 10px;">科技成果转化公共服务平台</span>
				</div>
				<div class="rightBox">
					<div class="menuTopContent">
						<a-menu v-model:selectedKeys="current" mode="horizontal" @click="menuClick">
							<a-menu-item v-for="item in list" :key="item.key">{{ item.title
							}}</a-menu-item>
						</a-menu>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="menuTopBox">
			<div class="menuTopContent">
				<a-menu v-model:selectedKeys="current" mode="horizontal" @click="menuClick">
					<a-menu-item v-for="item in list" :key="item.key">{{ item.title
					}}</a-menu-item>
				</a-menu>
			</div>
		</div> -->
	</div>
</template>
<script>
import {file_service, login_mp} from "@/api/adminService";
import {ls} from "@/utils/util";

export default {
	name: "educationHerder",
	data() {
		return {
			user: {},
			current: ["首页"],
			formState: {
				user: null,
			},
			all_logo: '',
			list: [
				{
					id: '1',
					title: "首页",
					url: '/achievements/index',
					key: "首页"
				},

				// {
				// 	id: '3',
				// 	title: "优质项目",
				// 	url: "/achievements/components/corpProject",
				// 	key: "优质项目"
				// },
				{
					id: '2',
					title: "通知公告",
					url: "/achievements/components/consultation",
					key: "通知公告"
				},
				{
					id: '3',
					title: "技术合同",
					url: "/achievements/components/agreement",
					key: "技术合同"
				},
				{
					id: '4',
					title: "成果交易",
					url: "/achievements/components/achievementRequirements",
					key: "成果交易"
				},
				{
					id: '5',
					title: "成果展示",
					url: '/achievements/components/achievement',
					key: "成果展示"
				},
			]
		}
	},
	mounted() {
		if (ls.get('token') && ls.get("refresh_token")) {
			this.user.userName = this.$ls.get('userName')
			this.user.phoneNumber = this.$ls.get('phoneNumber')
		}
		this.current = this.$route.query.type
		this.all_logo = this.$ls.get('all_logo');
	},
	// watch:{
	// 	$route(){
	// 		let a = []
	// 		a.push(this.$route.query.type)
	// 		this.current = a
	// 		// this.current = this.$route.query.type
	// 	}
	// },
	methods: {
        goHttp(url) {
            window.open(url, '_bank')
        },
		getImg(imgUrl) {
			return file_service.imagesWeb(imgUrl)
		},
		islogin() {
			if (ls.get('token') && ls.get("refresh_token")) {
				if (ls.get("roleCode").includes('company')) {
					this.goMore('/sys/companyInfo')
				} else if (ls.get("roleCode").includes('technicalManager')) {
					this.goMore('/sys/technology/person');
				} else if (ls.get("roleCode").includes('bank')) {
                this.goMore('/finance/financingInstitutionInformation');
                }else {
					this.goMore('/sys/userInfo')
				}
			} else {
				this.goMore('/login', 'user')
			}
		},
		logout() {
			let self = this;

			self.$ls.clear();
			self.$store.commit('setMenuData', []);
			self.$router.replace('/');

			location.reload();
		},
		onLogout() {
			let self = this;
			self.$confirm({
				title: '确认要退出登录?',
				content: '',
				onOk() {
					self.postAction({
						url: login_mp.saveLog,
						params: { logAppCategoryEnum: "LOGOUT" }
					}).then(res => {
						console.log(res)
						self.getAction({
							url: login_mp.logout,
							params: { access_token: ls.get("token") || "" },
							isValid: false
						}).then(() => {
							self.$notification['success']({
								message: '退出成功',
								style: {
									fontWeight: '600',
								},
							});
						})
					})


					setTimeout(() => {
						self.logout();
					}, 2000)
				},
				onCancel() {
				},
			});
		},
		backhome() {
			this.$router.push('/')
		},
		goMore(url, str) {
			this.$router.push({ path: url, query: { id: str } })
		},
		goMoreNotice(url, str) {
			this.$router.push({ path: url, query: { ...str } })
		},
		menuClick(e) {
			let obj = this.list.filter(i => i.key == e.key)[0] || {}
			this.$router.push({
				path: obj.url,
				query: { type: obj.key }
			})
		},
	}
}
</script>
<style scoped lang="less">
.smallHeaderBox {
	overflow: hidden;
	width: 100%;
	background-color: #ecf0f6;
	color: #666666;
	font-size: 14px;
	padding: 10px 0;

	.smallHeader {
		float: left;
	}

	.backhome {
		float: right;
		cursor: pointer;
		color: #1890ff;
	}
}

.headerBox {
	width: 100%;
	height: 92px;
	background-color: #fff;

	.hearderContentBox {
		width: 1200px;
		margin: 0 auto;

		.titleBox {
			float: left;
			line-height: 92px;
			font-size: 36px;
			font-weight: bold;

			.logoBox {
				float: left;
				width: 73px;
				height: 60px;
				margin-right: 5px;

				img {
					width: 100%;
					height: 100%;
				}
			}
		}

		.rightBox {
			width: 55%;
			float: right;
			margin-top: 2.5%;

			.menuTopContent {
				float: right;

				:deep(.ant-menu-horizontal) {
					border-bottom: none;
				}

				:deep(.ant-menu-horizontal:not(.ant-menu-dark)>.ant-menu-item) {
					text-align: center;
					padding: 0 20px 13px 20px;
					margin: 0 20px 0 0;
					font-size: 16px;
					color: #333;
				}

				:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected) {
					color: #1890ff;
					font-weight: bold;
				}
			}
		}
	}
}

// .menuTopBox {
// 	margin: 0 auto;
// 	width: 100%;
// 	background-color: #1d72ff;

// 	.menuTopContent {
// 		margin: 0 auto;
// 		width: 1200px;

// 		:deep(.ant-menu-horizontal) {
// 			background-color: #1d72ff;
// 		}

// 		:deep(.ant-menu-horizontal:not(.ant-menu-dark)>.ant-menu-item) {
// 			width: 14%;
// 			text-align: center;
// 			background-color: #1d72ff;
// 			color: #fff;
// 		}

// 		:deep(.ant-menu-horizontal:not(.ant-menu-dark)>.ant-menu-submenu) {
// 			width: 14%;
// 			text-align: center;
// 		}

// 		:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected) {
// 			background-color: #fc550b;
// 			color: #fff;
// 		}

// 		:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected) {
// 			background-color: #fc550b;
// 			color: #fff;
// 		}

// 		:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after) {
// 			border: none;
// 		}

// 		:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected::after) {
// 			border: none;
// 		}

// 		.floatRight {
// 			float: right;
// 			margin-top: -36px;
// 			width: 29%;
// 			overflow: hidden;
// 			white-space: nowrap;
// 			text-overflow: ellipsis;
// 			-o-text-overflow: ellipsis;
// 		}
// 	}
// }

:deep(.ant-menu-horizontal) {
	border-bottom: 2px solid #035aea;
}

:deep(.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after) {
	border-bottom: 2px solid #035aea;
}
</style>
